<template>
  <label>
    <span v-html="renderValue.label" /><tooltip
      v-if="showTooltip"
      :id="id"
      :content="renderValue.tooltip"
    />
  </label>
</template>

<script>
import Tooltip from '@/components/UI/Tooltip.vue';
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'LabelAndTooltip',
  components: { Tooltip },
  props: {
    value: {
      type: Object,
      default() {
        return null;
      }
    },
    label: {
      type: String,
      default() {
        return null;
      }
    },
    tooltip: {
      type: String,
      default() {
        return null;
      }
    },
    id: {
      type: String,
      default() {
        return '';
      }
    }
  },
  computed: {
    renderValue() {
      let data = {
        label: Utility.decodeHtml(this.label),
        tooltip: this.tooltip
      };

      if (this.label === null && this.tooltip === null && this.value !== null) {
        data = {
          label: Utility.decodeHtml(this.value.Label),
          tooltip: this.value.Tooltip
        };
      }

      return data;
    },
    showTooltip() {
      return this.renderValue.tooltip !== null;
    }
  }
};
</script>
